import { useIntl } from "react-intl";
import styles from "./ContractBlock.module.scss";

export const ContractBlock = () => {
  const intl = useIntl();

  return (
    <div className={styles.content}>
      <div className={styles.accordion}>
        <div className={styles.label}>
          {intl.formatMessage({ id: "license" })}
        </div>
      </div>
    </div>
  );
};
